/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./google-analytics.component";
import * as i2 from "../universal-config";
var styles_GoogleAnalyticsComponent = [];
var RenderType_GoogleAnalyticsComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_GoogleAnalyticsComponent, data: {} });
export { RenderType_GoogleAnalyticsComponent as RenderType_GoogleAnalyticsComponent };
export function View_GoogleAnalyticsComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_GoogleAnalyticsComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "google-analytics", [], null, null, null, View_GoogleAnalyticsComponent_0, RenderType_GoogleAnalyticsComponent)), i0.ɵdid(1, 638976, null, 0, i1.GoogleAnalyticsComponent, [i2.Config, "isBrowser"], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var GoogleAnalyticsComponentNgFactory = i0.ɵccf("google-analytics", i1.GoogleAnalyticsComponent, View_GoogleAnalyticsComponent_Host_0, { profile: "profile" }, {}, []);
export { GoogleAnalyticsComponentNgFactory as GoogleAnalyticsComponentNgFactory };
//# sourceMappingURL=google-analytics.component.ngfactory.js.map